/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, fonts } from '@blend/consumer-components';
import { generateInnerHtml } from '@blend/shared-react';

const styles = StyleSheet.create({
  taskMessagePrimaryHeading: {
    ...fonts.UntitledSans,
    marginBottom: 24,
    color: colors.darkerGray,
    fontSize: 24,
    lineHeight: 7 / 6,
    fontWeight: 500,
  },
});

export namespace PrimaryHeading {
  export interface Props {
    display: string;
  }
}

export const TaskMessagePrimaryHeading: React.FC<PrimaryHeading.Props> = ({ display }) => (
  <h2 className={css(styles.taskMessagePrimaryHeading)} {...generateInnerHtml(display)} data-dd-privacy="allow" />
);
